<template>
  <div class="usersExample">
    <div class="tabLabel">
      <div
        class="tabsItem"
        @click="onChange(0)"
        :class="index === 0 ? 'tabsItemActive' : ''"
      >
        学生
      </div>
      <div
        class="tabsItem"
        @click="onChange(1)"
        :class="index === 1 ? 'tabsItemActive' : ''"
      >
        个体户
      </div>
      <div
        class="tabsItem"
        @click="onChange(2)"
        :class="index === 2 ? 'tabsItemActive' : ''"
      >
        数据分析师
      </div>
      <div
        class="tabsItem"
        @click="onChange(3)"
        :class="index === 3 ? 'tabsItemActive' : ''"
      >
        数字岗位人员
      </div>
    </div>
    <Tabs name="tab1" v-model="index" @on-click="onChange">
      <TabPane>
        <div class="usersExampleItem">
          <indexUsersStudents></indexUsersStudents>
        </div>
      </TabPane>
      <TabPane>
        <indexUsersBusinessman></indexUsersBusinessman>
      </TabPane>
      <TabPane>
        <indexUsersAnalyst></indexUsersAnalyst>
      </TabPane>
      <TabPane>
        <indexUsersManagement></indexUsersManagement>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import indexUsersStudents from "./user-example/index-users-students.vue";
import indexUsersAnalyst from "./user-example/index-users-analyst.vue";
import indexUsersManagement from "./user-example/index-users-management.vue";
import indexUsersBusinessman from "./user-example/index-users-businessman.vue";
export default {
  components: {
    indexUsersStudents,
    indexUsersAnalyst,
    indexUsersManagement,
    indexUsersBusinessman
  },
  data() {
    return {
      index: 0
    };
  },
  methods: {
    onChange(index) {
      this.index = index;
    }
  }
};
</script>
<style>
.usersExample .ivu-tabs-bar {
  border-bottom: none;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
}
.usersExample .ivu-tabs-nav .ivu-tabs-tab {
  margin-left: 5px;
  margin-right: 5px;
}
/* .usersExample .ivu-tabs-nav-scroll {
  display: flex;
  justify-content: center;
  align-items: center;
} */
.usersExample .ivu-tabs-ink-bar {
  display: none !important;
}
.usersExample .ivu-tabs-tab-active {
  border-bottom: 3px solid #2d8cf0;
}
.usersExample .ivu-tabs-nav-scroll {
  overflow: visible !important;
}
</style>
<style scoped>
.tabLabel {
  display: flex;
  justify-content: center;
}
.tabsItem {
  padding: 8px 20px;
  padding-bottom: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tabsItemActive {
  padding: 8px 20px;
  border-bottom: 2px solid #2d8cf0;
}
@media screen and (min-width: 1400px) {
  .usersExample {
    padding: 30px 0;
    padding-bottom: 10px;
    padding-left: 15vw;
    padding-right: 15vw;
  }
}
@media screen and (max-width: 1400px) {
  .usersExample {
    padding: 20px 0;
    padding-bottom: 8px;
    padding-left: 10vw;
    padding-right: 10vw;
  }
}
@media screen and (max-width: 1000px) {
  .usersExample {
    padding: 5px 0;
    padding-bottom: 5px;
    padding-left: 8vw;
    padding-right: 8vw;
  }
}
@media screen and (max-width: 960px) {
  .usersExample {
    padding: 5px 0;
    padding-left: 13px;
    padding-right: 13px;
  }
}
.usersExampleItem {
  padding: 20px 0;
}
</style>
